export default function useDelay() {
    return delay => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            },delay);
        });
    }
}